import { render, staticRenderFns } from "./WYSIWYG.vue?vue&type=template&id=504c7e17"
import script from "./WYSIWYG.vue?vue&type=script&lang=js"
export * from "./WYSIWYG.vue?vue&type=script&lang=js"
import style0 from "./WYSIWYG.vue?vue&type=style&index=0&id=504c7e17&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports